import { baseGet, basePost } from "@/utils/api/base";
import apiEndPointsList from "../constant/apiEndPointsList";

const sectorService = {
    getAllNestedSectors: async () => {
        const response = await baseGet({
            endpoint: apiEndPointsList.sector.NESTED_SECTORS,
        });
        return response.data;
    },
    
    getSectorById: async (id) => {
        const response = await baseGet({
            endpoint: apiEndPointsList.sector.SECTOR_BY_ID(id),
        });
        return response.data;
    },
}

export default sectorService;

